
/* CATEGORY */
export const GET_CATEGORY_LISTING = "GET_CATEGORY_LISTING";
export const GET_CATEGORY_LISTING_SUCCESS = "GET_CATEGORY_LISTING_SUCCESS";
export const GET_CATEGORY_LISTING_FAIL = "GET_CATEGORY_LISTING_FAIL";

export const GET_CATEGORY_DETAILS = "GET_CATEGORY_DETAILS";
export const GET_CATEGORY_DETAILS_SUCCESS = "GET_CATEGORY_DETAILS_SUCCESS";
export const GET_CATEGORY_DETAILS_FAIL = "GET_CATEGORY_DETAILS_FAIL";

export const ADD_CATEGORY = "ADD_CATEGORY";
export const ADD_CATEGORY_SUCCESS = "ADD_CATEGORY_SUCCESS";
export const ADD_CATEGORY_FAIL = "ADD_CATEGORY_FAIL";

export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const UPDATE_CATEGORY_SUCCESS = "UPDATE_CATEGORY_SUCCESS";
export const UPDATE_CATEGORY_FAIL = "UPDATE_CATEGORY_FAIL";

export const BULK_UPDATE_CATEGORY = "BULK_UPDATE_CATEGORY";
export const BULK_UPDATE_CATEGORY_SUCCESS = "BULK_UPDATE_CATEGORY_SUCCESS";
export const BULK_UPDATE_CATEGORY_FAIL = "BULK_UPDATE_CATEGORY_FAIL";

export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const DELETE_CATEGORY_SUCCESS = "DELETE_CATEGORY_SUCCESS";
export const DELETE_CATEGORY_FAIL = "DELETE_CATEGORY_FAIL";

export const BULK_DELETE_CATEGORY = "BULK_DELETE_CATEGORY";
export const BULK_DELETE_CATEGORY_SUCCESS = "BULK_DELETE_CATEGORY_SUCCESS";
export const BULK_DELETE_CATEGORY_FAIL = "BULK_DELETE_CATEGORY_FAIL";

export const EXPORT_CATEGORY = "EXPORT_CATEGORY";
export const EXPORT_CATEGORY_SUCCESS = "EXPORT_CATEGORY_SUCCESS";
export const EXPORT_CATEGORY_FAIL = "EXPORT_CATEGORY_FAIL";

export const RESET_CATEGORY_STATE = 'RESET_CATEGORY_STATE';
export const RESET_CATEGORY_ATTACHMENT_STATE = 'RESET_CATEGORY_ATTACHMENT_STATE';